<template>
  <v-container>
    <v-tabs fixed icons centered style>
      <v-tabs-bar class="primary" style>
        <v-tabs-slider class="white"></v-tabs-slider>
        <v-tabs-item class="tbList" :lazy="true" style="color:white" href="#tab-3">
          <v-icon>bar_chart</v-icon>Statistics
          <br>
        </v-tabs-item>
        <v-tabs-item class="tbList" style="color:white" href="#tab-1">
          <v-icon>cloud</v-icon>Transfers
          <br>
        </v-tabs-item>
        <v-tabs-item class="tbList" :lazy="true" style="color:white" href="#tab-2">
          <v-icon>event</v-icon>Content
          <br>
        </v-tabs-item>
      </v-tabs-bar>
      <v-tabs-items style>
        <v-tabs-content id="tab-3">
          <div class="statsContainer">
            <v-layout row wrap>
              <v-flex xs12 md4>
                <v-layout justify-center>
                  <div class="statsValue">{{users.length}}</div>
                  <br>
                </v-layout>
                <v-layout justify-center>
                  <span class="statsLabel">network members</span>
                  <br>
                </v-layout>
              </v-flex>
              <v-flex xs12 md4>
                <v-layout justify-center>
                  <div
                    class="statsValue"
                  >{{allArtefacts.reduce((acc,cur)=>{return acc = acc+cur.uniqueVisits.length},0)}}</div>
                  <br>
                </v-layout>
                <v-layout justify-center>
                  <span class="statsLabel">Visits</span>
                  <br>
                </v-layout>
              </v-flex>
              <v-flex xs12 md4>
                <v-layout justify-center>
                  <div class="statsValue">{{users.filter(user=>user.role=="Contributor").length}}</div>
                  <br>
                </v-layout>
                <v-layout justify-center>
                  <span class="statsLabel">Contributors</span>
                  <br>
                </v-layout>
              </v-flex>
              <v-flex xs12 md4>
                <v-layout justify-center>
                  <div class="statsValue">{{allArtefacts.length}}</div>
                  <br>
                </v-layout>
                <v-layout justify-center>
                  <span class="statsLabel">Posts</span>
                  <br>
                </v-layout>
              </v-flex>
              <v-flex xs12 md4>
                <v-layout justify-center>
                  <div class="statsValue">{{collections.length}}</div>
                  <br>
                </v-layout>
                <v-layout justify-center>
                  <span class="statsLabel">Collections</span>
                  <br>
                </v-layout>
              </v-flex>
              <v-flex xs12 md4>
                <v-layout justify-center>
                  <div class="statsValue">{{groups.length}}</div>
                  <br>
                </v-layout>
                <v-layout justify-center>
                  <span class="statsLabel">Groups</span>
                  <br>
                </v-layout>
              </v-flex>
            </v-layout>
            <br>
            <br>
            <!-- <p>Registered users no: {{users.length}}</p>
            <p>Visits no: {{artefacts.reduce((acc,cur)=>{return acc = acc+cur.uniqueVisits.length},0)}}</p>
            <p>Contrib no: {{users.filter(user=>user.role=="Contributor").length}}</p>-->
            <p class="statsTitle">Top 10 favourited artefacts</p>

            <v-layout row wrap justify-center>
              <v-flex  md6 sm12 v-for=" i in 10 " :key="i" v-if="favart.length>i">
                <div @click="goTo(favart[i-1]._id,'artefacts')" class="miniCard" >{{i}}.  {{favart[i-1].title[lang]}} <span class="favouriteState">{{favart[i-1].favorite.length}} </span> </div>  
              </v-flex>
            </v-layout>
            <p class="statsTitle">Top 10 artefacts</p>
            <v-layout row wrap justify-center>
              <v-flex  md6 sm12 v-for=" i in 10 " :key="i" v-if="artefacts.length>i">
                <div @click="goTo(artefacts[i-1]._id,'artefacts')" class="miniCard" >{{i}}.  {{artefacts[i-1].title[lang]}} <span class="favouriteState">{{artefacts[i-1].uniqueVisits.length}} </span> </div>  
              </v-flex>
            </v-layout>
            <p class="statsTitle">Top 10 collections</p>

            <v-layout row wrap justify-center>
              <v-flex  md6 sm12 v-for=" i in 10 " :key="i" v-if="collections.length>i">
                <div @click="goTo(collections[i-1]._id,'collections')" class="miniCard" >{{i}}.  {{collections[i-1].title[lang]}} <span class="favouriteState">{{collections[i-1].uniqueVisits.length}} </span> </div>  
              </v-flex>
            </v-layout>

            <p class="statsTitle">top 10 groups</p>

            <v-layout row wrap justify-center>
              <v-flex  md6 sm12 v-for=" i in 10 " :key="i" v-if="groups.length>i">
                <div @click="goTo(groups[i-1]._id,'groups')" class="miniCard" >{{i}}.  {{groups[i-1].title[lang]}} <span class="favouriteState">{{groups[i-1].uniqueVisits.length}} </span> </div>  
              </v-flex>
            </v-layout>

            <!-- <p>Top 10 artef fav: {{favart.slice(0,10).filter((art=>art.favorite.length!=0)).reduce((acc,cur)=> {return acc = acc +" "+cur.title.ro + " "+ cur.favorite.length+ "   "},"")}}</p>
             <p>Top 10 artef: {{artefacts.slice(0,10).reduce((acc,cur)=> {return acc = acc +" "+cur.title.ro + " "+ cur.uniqueVisits.length+ "   "},"")}}</p>
             <p>Top 10 coll: {{collections.slice(0,10).reduce((acc,cur)=> {return acc = acc +" "+cur.title.ro + " "+ cur.uniqueVisits.length+ "   "},"")}}</p>
            <p>Top 10 groups: {{groups.slice(0,10).reduce((acc,cur)=> {return acc = acc +" "+cur.title.ro + " "+ cur.uniqueVisits.length+ "   "},"")}}</p>-->
          </div>
        </v-tabs-content>
        <v-tabs-content class="white" id="tab-1">
          <v-layout style="border:1px solid #efefef" justify-center row wrap>
            <v-btn href="/api/restore/export" download class="ma-3 pa-2">Export Database
              <v-icon color="grey lighten-1">file_download</v-icon>
            </v-btn>

            <v-btn
              style="width:300px;"
              color="primary"
              class="ma-3 pa-2"
              v-bind:class="{ 'green darken-3' : status }"
              :loading="loading"
              @click="clickInputMain()"
            >Import Database as Json
              <v-icon right dark>cloud_upload</v-icon>
            </v-btn>
            <form
              enctype="multipart/form-data"
              novalidate
              v-if="isInitial || isSaving || isSuccess"
            >
              <input
                type="file"
                name="exports"
                style="display:none"
                :disabled="isSaving"
                @change="filesChange($event.target.name, $event.target.files, -1); fileCount = $event.target.files.length"
                accept="application/json"
                class="input-file"
                ref="fileInput1"
              >
            </form>

            <v-btn
              href="/api/restore/exportfiles"
              @click="alertit()"
              download
              class="ma-3 pa-2"
            >Export User Uploads
              <v-icon color="grey lighten-1">file_download</v-icon>
            </v-btn>
          </v-layout>
        </v-tabs-content>
        <v-tabs-content id="tab-2">
          <div class="masonry1" row wrap>
            <div xs12 sm6 md4 v-for="(element,i) in gLang[lang]" class="item1" :key="i">
              <v-card elevation-4 class="pa-3 ma-1 variableWidth">
                <div class="text-xs-center">
                  <h3>{{i.toUpperCase()}}</h3>
                </div>

                <div v-for="(field,i) in element" :key="i">
                  <v-text-field :label="i" v-model="element[i]"></v-text-field>
                </div>
              </v-card>
            </div>
          </div>

          <v-layout justify-center>
            <v-btn @click="saveLanguage(gLang)" large round primary>Save</v-btn>
          </v-layout>

          <v-snackbar
            :timeout="timeout"
            :color="colorS"
            :multi-line="mode"
            :vertical="!mode"
            v-model="snackbarS"
          >Language updated successfully!
            <v-btn dark flat @click.native="snackbarS = false">Close</v-btn>
          </v-snackbar>

          <v-snackbar
            :timeout="timeout"
            :color="colorF"
            :multi-line="mode"
            :vertical="!mode"
            v-model="snackbarF"
          >Language update failed!
            <v-btn dark flat @click.native="snackbarF = false">Close</v-btn>
          </v-snackbar>
        </v-tabs-content>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>


<style >
.variableWidth {
  width: 500px;
}

.masonry1 {
  /* Masonry container */
  column-count: 3;
  column-gap: 2em;
}

@media screen and (max-width: 1900px) {
  .masonry1 {
    /* Masonry container */
    column-count: 2;
    column-gap: 1em;
  }

  .variableWidth {
    width: 500px;
  }
}

@media screen and (max-width: 1400px) {
  .masonry1 {
    /* Masonry container */
    column-count: 2;
    column-gap: 1em;
  }

  .variableWidth {
    width: 400px;
  }
}

@media screen and (max-width: 1000px) {
  .masonry1 {
    /* Masonry container */
    column-count: 2;
    column-gap: 1em;
  }

  .variableWidth {
    width: 350px;
  }
}

@media screen and (max-width: 900px) {
  .masonry1 {
    /* Masonry container */
    column-count: 1;
    column-gap: 1em;
  }

  .variableWidth {
    width: 600px;
  }
}

@media screen and (max-width: 600px) {
  .masonry1 {
    /* Masonry container */
    column-count: 1;
    column-gap: 1em;
  }

  .variableWidth {
    width: 100%;
  }
}

.item1 {
  /* Masonry bricks or child elements */
  display: inline-block;
  margin: 0 0 1em;
  width: 100%;
}

.tbList .tabs__item {
  color: rgba(255, 255, 255, 0.377) !important;
}
.tbList .tabs__item--active {
  color: white !important;
}

.statsContainer {
  background-color: white;
  padding: 50px;
  -webkit-box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.75);
  border: 1px solid #efefef;
}

.statsLabel {
  text-transform: uppercase;
  text-align: center;
  font-size: 20px;
  padding-top: 16px;
  margin-bottom: 16px;
}

.statsValue {
  font-size: 40px;
  border: 11px solid rgb(33, 150, 243);
  border-radius: 50%;
  width: 150px;
  height: 150px;
  text-align: center;
  padding-top: 40px;
}

.statsTitle {
  text-transform: uppercase;
  font-size: 28px;
  margin-top: 64px;
  text-align: center;
}

.miniCard {
  background-color: white;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(150, 150, 150, 1);
  -moz-box-shadow: 0px 0px 5px 0px rgba(150, 150, 150, 1);
  box-shadow: 0px 0px 5px 0px rgba(150, 150, 150, 1);

  padding: 16px;
  padding-right: 45px;
  margin: 16px;
  position: relative;
  cursor: pointer;
  transition: all 0.5s;
}

.miniCard:hover {
  -webkit-box-shadow: 0px 0px 10px 1px rgba(150, 150, 150, 1);
  -moz-box-shadow: 0px 0px 10px 1px rgba(150, 150, 150, 1);
  box-shadow: 0px 0px 10px 1px rgba(150, 150, 150, 1);
  transform: scale(1.05);
}

.favouriteState {
  background-color: black;
  color: white;
  border-radius: 100%;
  padding: 4px;
  padding-left: 10px;
  padding-right: 10px;

  position: absolute;
  right: 16px;
}
</style>




<script>
import { Uploader } from "@/components/Mixins/fileUploader.import.js";
export default {
  mixins: [Uploader],
  data() {
    return {
      errorMessage: "",
      e1: true,
      status: 0,
      loading: false,
      timeout: 6000,
      colorS: "info",
      colorF: "red",
      mode: true,
      snackbarF: false,
      snackbarS: false
    };
  },
  computed: {
    favart() {
      return this.$store.getters.getFavoriteArtefacts;
    },
    users() {
      return this.$store.getters.loadUsers;
    },
    artefacts() {
      return this.$store.getters.loadPopularArtefacts;
    },
    collections() {
      return this.$store.getters.loadAllCollections;
    },
    groups() {
      return this.$store.getters.loadGroups;
    },
    allArtefacts() {
      return this.$store.getters.loadArtefacts;
    }
  },
  methods: {
    goTo(link, object) {
      console.log("hboefvwemrbevfn");
      this.$router.push("/" + object + "/" + link);
    },
    alertit() {
      alert("we're is archiving user uploaded files, it may take a while");
    },
    downloadDatabase() {},
    saveLanguage(lang) {
      console.log(lang);
      this.$store.dispatch("updateLang", { lang: lang }).then(response => {
        if (response.data) {
          this.snackbarS = true;
        } else {
          this.snackbarF = true;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Administration/Settings.vue